
:host > smoothly-button {
	display: block;
	margin-block: 2rem;
}
